/**
 * A raw VEOS status rendered as a design-system `Badge`, through a
 * declarative {@link StatusBadgeConfig} (label + variant per value).
 * `null` / blank ⇒ renders nothing.
 *
 * Presentational building block of the extranet cards — not a registered
 * configurable component by itself.
 */

import { Badge, type BadgeSize } from '@components/base/display';

import { resolveStatusBadge, type StatusBadgeConfig } from './statusBadgeConfig';

export interface StatusBadgeProps {
  /** Raw status value as returned by VEOS. */
  value: string | number | null | undefined;
  config: StatusBadgeConfig;
  size?: BadgeSize;
}

export function StatusBadge({ value, config, size = 'sm' }: Readonly<StatusBadgeProps>) {
  const badge = resolveStatusBadge(value, config);
  if (badge === null) return null;
  return (
    <Badge variant={badge.variant} size={size} dot={badge.dot} data-status-value={String(value)}>
      {badge.label}
    </Badge>
  );
}
